var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPurple(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7688 6.73509H9.26491V1.23119C9.26491 -0.410396 6.73509 -0.410396 6.73509 1.23119V6.73509H1.23119C-0.410396 6.73509 -0.410396 9.26491 1.23119 9.26491H6.73509V14.7688C6.73509 16.4104 9.26491 16.4104 9.26491 14.7688V9.26491H14.7688C16.3911 9.28431 16.3911 6.73509 14.7688 6.73509Z",
    fill: "#002E6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPurple);
export default __webpack_public_path__ + "static/media/add_purple.0dc6b9edd1257d6241a5bd06210306b9.svg";
export { ForwardRef as ReactComponent };